module.exports = {
    "Empty": `Pr\xe1zdne`
};


//# sourceMappingURL=sk-SK.main.js.map
